import ko from 'knockout';
import _ from 'lodash';
import moment from 'moment';

export default class jobVersionObj {

    constructor(data) {

        console.log("Job Version Obj");
        console.log(data);
        this.componentname = "jobVersionObj";
        
        /*
        {
            "id": 0,
            "jobid": 0,
            "data": "string",
            "version": 0,
            "vaild": 0,
            "notes": "string",
            "createdate": "2017-12-03T19:01:44.412Z",
            "jdmuserid": 0,
            "statusid": 0,
            "reviewId": 0
        }
        */

        this.id = 0
        this.jobid = 0
        this.data = "";
        this.version = 0;
        this.valid = 1
        this.notes = "";
        this.createdate = moment().format('YYYY-MM-DD hh:mm:ss');
        this.jdmuserid = 0;
        this.statusid = 1;
        this.reviewId = null;

        if(data)
        {
            this.init(data);
        }
        
    }

    init(data) {

        this.id = data.id;
        this.jobid = data.jobid;
        this.data = data.data;
        this.version = data.version;
        this.valid = data.valid;
        this.notes = data.notes;
        this.createdate = moment().format('YYYY-MM-DD hh:mm:ss');
        this.jdmuserid = data.jdmUserID;
        this.statusid = data.statusid;
        this.reviewId = data.reviewId;
    }

    updateWithJob(selectedJob)
    {
        console.log("jobVersionObj:updateWithJob: %o", selectedJob);
        
        this.jobid = selectedJob.jobid();

    }

}

//export let  subTopicObj = new subTopicObjModel();


// WEBPACK FOOTER //
// ./src/objects/jobVersionObj.js